import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

const AuthLayout: React.FC = () => (
    <Box
        sx={(theme) => ({
            minHeight: '100vh',
            bgcolor: theme.palette.hfLayout.surface
        })}
    >
        <Outlet />
    </Box>
);

export default AuthLayout;
